import { Component } from 'vue-property-decorator';

// https://class-component.vuejs.org/guide/additional-hooks.html
Component.registerHooks(['beforeRouteEnter', 'beforeRouteLeave', 'beforeRouteUpdate']);
